import {gql} from '@apollo/client'

export const PARENTAL_LEAVE_REQUEST = gql`
  query parentalLeaveRequest($employeeId: ID!) {
    client {
      employee(employeeId: $employeeId) {
        id
        staffCode
        displayFullName
        user {
          id
          email
        }
      }
    }
  }
`

export interface ParentalLeaveRequestQueryVariables {
  employeeId: string
}

export interface ParentalLeaveRequestQueryResult {
  client: {
    employee: Employee
  }
}

export interface Employee {
  id: string
  staffCode: string
  displayFullName: string
  user?: {
    id: string
    email: string
  }
}
